module.exports = __webpack_public_path__ + "img/aboutus2880.673570de.png";